import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import type { GetMediaDto } from '@/types/dtos/media/request/get-media.dto.ts';
import type { GetMediaResponseDto } from '@/types/dtos/media/response/get-media.dto.ts';

export const GET_MEDIA_QUERY_KEY = 'get-media';
const PAGE_SIZE = '50';

export const useGetMediaQuery = (mediaDto: GetMediaDto) => {
  const { getToken } = useAuth();

  return useInfiniteQuery({
    queryKey: [GET_MEDIA_QUERY_KEY, mediaDto.parentId],
    queryFn: async ({ pageParam }) => {
      const token = await getToken();
      return getMedia({ mediaDto, pageParam, token: token ?? '' });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.pagination.nextCursor,
    enabled: !!mediaDto.parentType && !!mediaDto.parentId,
  });
};

const getMedia = async ({
  mediaDto,
  pageParam,
  token,
}: {
  mediaDto: GetMediaDto;
  pageParam: string;
  token: string;
}): Promise<GetMediaResponseDto> => {
  const { parentId, parentType } = mediaDto;
  const searchParams = new URLSearchParams({ limit: PAGE_SIZE });
  if (pageParam !== '') {
    searchParams.append('cursor', pageParam);
  }
  const url = `${import.meta.env.VITE_API_URL}/media/${parentType}/${parentId}?${searchParams.toString()}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
